import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div`
  padding: 0px 6px;
  background-color: ${colorsV2.white100};
  box-shadow: 1px 2px 0px ${colorsV2.gray60};

  border: 1px solid ${colorsV2.gray60};
  border-radius: 4px;
`;

interface KeyboardInstructionItemProps {
  text: string;
}

export const KeyboardInstructionItem = (props: KeyboardInstructionItemProps) => {
  const { text } = props;

  return (
    <Main className="keyboard-instruction-item">
      <ResponsiveTypography.Paragraph variant="semi-bold/12-20" color="black80">
        {text}
      </ResponsiveTypography.Paragraph>
    </Main>
  );
};
